import type { IconNode } from '../types';

/**
 * @name circle-letter-r
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTEgMTIgNCA0IiAvPgogIDxwYXRoIGQ9Ik05IDEyaDRhMiAyIDAgMCAwIDAtNEg5LjVhLjUuNSAwIDAgMC0uNS41VjE2IiAvPgogIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjEwIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/circle-letter-r
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const CircleLetterR: IconNode = [
  ['path', { d: 'm11 12 4 4' }],
  ['path', { d: 'M9 12h4a2 2 0 0 0 0-4H9.5a.5.5 0 0 0-.5.5V16' }],
  ['circle', { cx: '12', cy: '12', r: '10' }],
];

export default CircleLetterR;
